// eslint doesn't detect decorators as used

import { action, makeAutoObservable } from 'mobx';
import { ModalEnum } from '@uplift/types';

export class ModalStore {
  modals = {
    congratulation: false,
    submitSession: false,
    cancelSession: false,
    rematchProvider: false,
  };

  data: any = {};

  constructor() {
    makeAutoObservable(this);
  }

  isVisible(modalType: ModalEnum): boolean {
    return this.modals[modalType];
  }

  @action
  openModal(modalType: ModalEnum, props?: any) {
    this.modals[modalType] = true;
    this.data = props ?? {};
  }

  @action
  closeModal(modalType: ModalEnum) {
    this.modals[modalType] = false;
    this.data = {};
  }
}
